import React from 'react'
import {useTranslation} from 'react-i18next'
import {Box} from '@material-ui/core'
import {ReactComponent as LogoSvg} from 'assets/logo.svg'
import useStyles from './styles'

const Loader: React.FC = () => {
  const classes = useStyles()
  const {t} = useTranslation(['infoMessages'])

  return (
    <Box className={classes.container}>
      <Box className={classes.loader}>
        <Box className={classes.pacman} />
        <Box className={classes.bols}>
          <Box />
          <Box />
          <Box />
        </Box>
        <LogoSvg className={classes.logo} />
        <Box className={classes.text}>{t('loadingPleaseWait')}</Box>
      </Box>
    </Box>
  )
}

export default Loader
